import { stylesheet } from 'typestyle';

const styles = stylesheet({
  termsModalText: {
    fontSize: '16px !important',
    letterSpacing: '-.12px',
    textAlign: 'center',
    height: '100%',
  },
  termsModalContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  termsModalHeaderText: {
    fontSize: '24px !important',
    marginBottom: 20,
  },
  termsModalInstructionText: {
    fontSize: '18px !important',
    marginBottom: 15,
  },
  termsIFrameContainer: {
    borderWidth: 1,
    borderStyle: 'solid',
  },
  termsContentContainer: {
    border: 'none',
    width: '100%',
    pointerEvents: 'auto',
  },
  bottomButtonsContainer: {
    marginTop: 15,
  },
});

export default styles;
